import { render, staticRenderFns } from "./DataTableWithoutFilter.vue?vue&type=template&id=a9f68668"
import script from "./DataTableWithoutFilter.vue?vue&type=script&lang=js"
export * from "./DataTableWithoutFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports